module.exports = __webpack_public_path__ + "img/eye-button-invisible.e75b13a9.svg";